import useAppStore from "../../store/AppStore";
import ListingAddonCard from "./ListingAddonCard";
import {ListingAddonCardDataType} from "../../interfaces/listingAddonCard/ListingAddonCard.type";
import styles from "./ListingAddonCard.module.css";

export default function ListingAddonCardContainer({ items }: { items: ListingAddonCardDataType[] }) {
  const { isDeviceMobile } = useAppStore();
  const item = items[0];

  return (
      <div className={`vas-w-100 vas-px-3 ${styles.py_25}`}>
        <ListingAddonCard item={item} />
    </div>
  );
}
